import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            //搜索学生的条件
            searchStudent: {
                name: '',
                idcard: '',
                score: '',
                is_pass: '',
                category_name: '',
                start_exam_time: '',
                end_exam_time: '',
            },
            yesOrNo: ['是', '否'],
            // 课程类型
            courseStyle: ['专业课', '选修课'],
            // 学习状态
            studyType: ['未开始', '学习中', '已完成'],
            // 学生数据
            studnetData: [],
            //绑定在输入框的学员信息
            stuInfo: {},
            //已经勾选了多少个学生
            paruseStudent: [],
            //查看学员信息弹出框
            dialogTabelVisible: false,
            // 修改学员成绩弹出框
            alertDialoglVisible: false,
            // loading状态
            fullscreenLoading: false,
            // 总学员数
            studentTotal: 0,
            // 分页器每页的数量
            pageLen: 15,
            // 当前页数
            currentPage: 1,
            offset: 0,
            // 导出显示加载中
            exportLoading: false,
            // 导出excel
            excelDialog: false,
            exceldata: {
                offset: 0,
                length: 0
            },
        }
    },
    methods: {
        // 搜索
        confirmSearch() {
            this.offset = 0;
            this.currentPage = 1
            this.getAllStudent()
        },
        //点击学员多选框
        handleStudentChange(val) {
            if (val.length != 0) {
                this.stuInfo = val[0]
                let arr = [];
                for (let item of val) {
                    arr.push(item.id);
                }
                this.paruseStudent = arr;
            }
        },
        // 查看单个学员
        lookStudent() {

            if (this.paruseStudent.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请选择用户'
                })
                return false
            } else if (this.paruseStudent.length > 1) {
                this.$message({
                    type: 'error',
                    message: '请选择单个用户'
                })
                return false
            } else {
                this.dialogTabelVisible = true;
            }
        },
        //改变分页器每页数量
        handleSizeChange(val) {
            this.pageLen = val;
            this.getAllStudent();
        },
        //改变分页器当前页数
        getStudentPage(currentPage) {
            this.currentPage = currentPage;
            this.offset = (Number.parseInt(currentPage) - 1) * this.pageLen;
            this.confirmSearch()

        },
        //修改学员信息
        ModifyStudent() {

            if (this.paruseStudent.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请选择用户'
                })
                return false
            } else if (this.paruseStudent.length > 1) {
                this.$message({
                    type: 'error',
                    message: '请选择单个用户'
                })
                return false
            } else {
                this.alertDialoglVisible = true;
            }
        },
        //获取所有学生的信息
        getAllStudent() {
            this.fullscreenLoading = true
            this.searchType = true;
            this.$post('userAdmin/examResult', {
                token: this.$store.state.authority_management,
                offset: this.offset,
                length: this.pageLen,
                score: this.searchStudent.score,
                name: this.searchStudent.name,
                idcard: this.searchStudent.idcard,
                is_pass: this.searchStudent.is_pass,
                category_name: this.searchStudent.category_name,
                start_exam_time: this.searchStudent.start_exam_time,
                end_exam_time: this.searchStudent.end_exam_time,
            }).then(res => {
                this.studentTotal = res.data.result.total;
                this.studnetData = res.data.result.result;
                this.fullscreenLoading = false
            })
        },

        // 保存修改信息
        saveEdit() {
            this.$post('userAdmin/updateExamResult', {
                token: this.$store.state.authority_management,
                exam_id: this.stuInfo.id,
                category_id: this.stuInfo.category_id,
                category_name: this.stuInfo.category_name,
                score: this.stuInfo.score,
                is_pass: this.stuInfo.is_pass,
                exam_time: this.stuInfo.exam_time,
                start_exam_time: this.stuInfo.start_exam_time,
                end_exam_time: this.stuInfo.end_exam_time,
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败，请稍后重试');
                }
                this.alertDialoglVisible = false;
            });

        },

        // 点击删除按钮
        handleDeleteExamResult() {
            if (this.paruseStudent.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请选择用户'
                })
                return;
            }

            this.$confirm('是否删除选择的考试结果?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteExamResult();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },


        // 确定删除
        deleteExamResult() {
            this.$post('userAdmin/updateExamResult', {
                token: this.$store.state.authority_management,
                examIds: JSON.stringify(this.paruseStudent)
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('删除失败，请稍后重试');
                }
                this.getAllStudent();
            });
        },


        // 导出excel
        exportExcel() {
            this.excelDialog = true;
        },

        // 确认导出
        confirmexport() {
            this.exportLoading = true;
            this.excelDialog = false;
            let data = {
                token: this.$store.state.authority_management,
                offset: this.exceldata.offset,
                length: this.exceldata.length
            }
            if (this.searchStudent.name) {
                data.name = this.searchStudent.name
            }
            if (this.searchStudent.idcard) {
                data.idcard = this.searchStudent.idcard
            }
            if (this.searchStudent.score) {
                data.score = this.searchStudent.score
            }
            if (this.searchStudent.is_pass) {
                data.is_pass = this.searchStudent.is_pass
            }
            if (this.searchStudent.category_name) {
                data.category_name = this.searchStudent.category_name
            }
            if (this.searchStudent.start_exam_time) {
                data.start_exam_time = this.searchStudent.start_exam_time
            }
            if (this.searchStudent.end_exam_time) {
                data.end_exam_time = this.searchStudent.end_exam_time
            }

            this.$post('userAdmin/examResultExport', data).then(res => {
                this.exportLoading = false;
                window.open(res.data.result)
            })
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },
    },
    created() {
        this.getAllStudent()
    }

}
